import { Material, Mesh, PlaneBufferGeometry } from "three";

export default class extends Mesh {
  constructor(
    width,
    height,
    depth,
    widthSegments,
    heightSegments,
    baseMaterial,
    graphTexture
  ) {
    const object = new PlaneBufferGeometry(
      width,
      height,
      widthSegments,
      heightSegments
    );

    const material = baseMaterial.clone();

    material.onBeforeCompile = (shader, renderer) => {
      shader.vertexUvs = true;

      shader.uniforms.graphTexture = { value: graphTexture };
      shader.uniforms.graphResolution = {
        value: [graphTexture.image.width, graphTexture.image.height]
      };
      shader.uniforms.graphDepth = {
        value: depth
      };

      shader.vertexShader =
        "uniform sampler2D graphTexture;\n" +
        "uniform vec2 graphResolution;\n" +
        "uniform float graphDepth;\n" +
        shader.vertexShader
          .replace(
            "#include <beginnormal_vertex>",
            `#include <beginnormal_vertex>
{
  vec3 diff = vec3(1./graphResolution, 0.);
  float ndx = (
    texture2D(graphTexture, vUv.x > 1.-diff.x ? vUv : vUv+diff.xz).r
    - texture2D(graphTexture, vUv.x < diff.x ? vUv : vUv-diff.xz).r
  );
  ndx /= vUv.x < diff.x || vUv.x > 1.-diff.x ? diff.x : 2.*diff.x;
  float ndy = (
    texture2D(graphTexture, vUv.y > 1.-diff.y ? vUv : vUv+diff.yz).r
    - texture2D(graphTexture, vUv.y < diff.y ? vUv : vUv-diff.yz).r
  );
  ndy /= vUv.y < diff.y || vUv.y > 1.-diff.y ? diff.y : 2.*diff.y;

  objectNormal = normalize(cross(vec3(1.,ndx,0.), vec3(0., 1., ndy)));
}`
          )
          .replace(
            "#include <begin_vertex>",
            "#include <begin_vertex>\n" +
              "transformed.z = graphDepth*texture2D(graphTexture, vUv).r;"
          );

      material.userData.shader = shader;
    };

    super(object, material);
  }
}
